import { Facebook, Instagram, Twitter, Youtube, Linkedin, MessageCircle } from "lucide-react";

// Networks a vendor can link from the storefront footer. `hosts` mirrors the backend check.
export const NETWORKS = [
  { key: "facebook", label: "Facebook", icon: Facebook, hosts: ["facebook.com", "fb.com", "fb.me"], placeholder: "https://www.facebook.com/yourstore" },
  { key: "instagram", label: "Instagram", icon: Instagram, hosts: ["instagram.com", "instagr.am"], placeholder: "https://www.instagram.com/yourstore" },
  { key: "x", label: "X (Twitter)", icon: Twitter, hosts: ["x.com", "twitter.com"], placeholder: "https://x.com/yourstore" },
  { key: "youtube", label: "YouTube", icon: Youtube, hosts: ["youtube.com", "youtu.be"], placeholder: "https://www.youtube.com/@yourstore" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, hosts: ["linkedin.com"], placeholder: "https://www.linkedin.com/company/yourstore" },
  { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, hosts: ["wa.me", "whatsapp.com"], placeholder: "https://wa.me/919876543210" },
];
const BY_KEY = Object.fromEntries(NETWORKS.map((n) => [n.key, n]));

/** Configured links for the storefront context (`useStore()` value): [{network, url, label, icon}] in a fixed order. */
export function socialItems(s) {
  const items = s?.homepage?.sections?.social?.items || [];
  return NETWORKS.map((n) => {
    const hit = items.find((i) => i.network === n.key && i.url);
    return hit ? { network: n.key, url: hit.url, label: n.label, icon: n.icon } : null;
  }).filter(Boolean);
}

export function validSocialUrl(netKey, value) {
  try {
    const u = new URL(value.trim());
    const host = u.hostname.toLowerCase();
    return u.protocol === "https:" && BY_KEY[netKey].hosts.some((h) => host === h || host.endsWith(`.${h}`));
  } catch { return false; }
}
